/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPersonSpeaking = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 9.984C2 5.604 5.452 2 9.774 2c4.344 0 7.12 3.58 7.223 7.742l1.577 3.154.007.015a1.61 1.61 0 0 1-.664 2.07l-.643.432v1.59c0 .446-.227.79-.508.996a1.597 1.597 0 0 1-.642.267c-.277.053-.586.05-.73.05H13V22h-2v-4c0-.339.063-.705.272-1.028.224-.346.542-.53.836-.612.266-.075.513-.07.653-.062l.164.012.021.002.055.004h2.273V15.2c0-.572.303-1.111.81-1.397l.53-.356L15 10.22v-.236C15 6.534 12.828 4 9.774 4 6.614 4 4 6.65 4 9.984c0 1.836.982 3.662 2.295 4.78l.131.113 1.165 2.012-1.642 4.927-1.898-.632L5.41 17.11l-.544-.94C3.235 14.719 2 12.419 2 9.984zm11.003 7.958v.002zm7.014-1.072c.104-.389.044-.87-.298-1.353l1.631-1.157c.66.93.87 2.02.599 3.028-.27 1.01-.997 1.848-2.033 2.323l-.833-1.818c.537-.246.83-.633.934-1.022z" />
        <path d="M12 10h2v2h-2z" />
      </g>
    </g>
  </Icon>
);
export { SvgPersonSpeaking as PersonSpeaking };
